import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Time: Time;
};

export type AccessLogConnection = {
  __typename?: 'AccessLogConnection';
  edge: Array<PaperAccessLog>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type AccessToken = {
  __typename?: 'AccessToken';
  lastAccessedAt?: Maybe<Scalars['Time']>;
  name: Scalars['String'];
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  edge: Array<PaperComment>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type CreatedToken = {
  __typename?: 'CreatedToken';
  name: Scalars['String'];
  token: Scalars['String'];
};

export type FavoriteConnection = {
  __typename?: 'FavoriteConnection';
  edge: Array<PaperFavorite>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type FilterSearchInput = {
  filterByFavorite: Scalars['Boolean'];
  filterByReadStatus?: InputMaybe<PaperUserStatusName>;
  sortBy: FilterSearchSortBy;
};

export type FilterSearchResult = {
  __typename?: 'FilterSearchResult';
  edge: Array<FilteredPaper>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export enum FilterSearchSortBy {
  Favorite = 'FAVORITE',
  ReadStatus = 'READ_STATUS'
}

export type FilteredPaper = {
  __typename?: 'FilteredPaper';
  paperFavorite?: Maybe<PaperFavorite>;
  paperUserStatus?: Maybe<PaperUserStatus>;
};

export type Me = {
  __typename?: 'Me';
  accessLogs: AccessLogConnection;
  comments: CommentConnection;
  favorites: FavoriteConnection;
  notifications: UserNotificationConnection;
  readLaterPapers: ReadPaperConnection;
  readPapers: ReadPaperConnection;
  tags: PaperTagConnection;
  tokens: Array<AccessToken>;
};


export type MeAccessLogsArgs = {
  pagingInput: PagingInput;
};


export type MeCommentsArgs = {
  pagingInput: PagingInput;
};


export type MeFavoritesArgs = {
  pagingInput: PagingInput;
};


export type MeNotificationsArgs = {
  pagingInput: PagingInput;
};


export type MeReadLaterPapersArgs = {
  pagingInput: PagingInput;
};


export type MeReadPapersArgs = {
  pagingInput: PagingInput;
};


export type MeTagsArgs = {
  pagingInput: PagingInput;
};

export type MeSearchInput = {
  filterByFavorite: Scalars['Boolean'];
  filterByRead?: InputMaybe<Scalars['Boolean']>;
  filterByReadStatus?: InputMaybe<PaperUserStatusName>;
  sortBy: MeSearchSortBy;
};

export type MeSearchResult = {
  __typename?: 'MeSearchResult';
  edge: Array<MyPaper>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export enum MeSearchSortBy {
  Favorite = 'FAVORITE',
  Read = 'READ',
  ReadStatus = 'READ_STATUS'
}

export type Mutation = {
  __typename?: 'Mutation';
  createAccessToken: CreatedToken;
  createPaperAccessLog: PaperPayload;
  createPaperComment: MutationPaperCommentPayload;
  createPaperTag: PaperTagPayload;
  destroyAccessToken: Scalars['String'];
  destroyPaperComment: MutationPaperCommentPayload;
  destroyPaperCommentFavorite: PaperCommentFavorite;
  destroyPaperFavorite: PaperPayload;
  destroyTagFromPaper: PaperPayload;
  destroyTagToSlack?: Maybe<Tag>;
  updatePaperComment: MutationPaperCommentPayload;
  updatePaperCommentFavorite: PaperCommentFavorite;
  updatePaperFavorite: UpdatePaperFavoritePayload;
  updatePaperUserStatus: UpdatePaperUserStatusPayload;
  updateTagToSlack?: Maybe<Tag>;
};


export type MutationCreateAccessTokenArgs = {
  tokenName: Scalars['String'];
};


export type MutationCreatePaperAccessLogArgs = {
  paperInput: PaperInput;
};


export type MutationCreatePaperCommentArgs = {
  comment: Scalars['String'];
  paperInput: PaperInput;
};


export type MutationCreatePaperTagArgs = {
  name: Scalars['String'];
  paperInput: PaperInput;
};


export type MutationDestroyAccessTokenArgs = {
  tokenName: Scalars['String'];
};


export type MutationDestroyPaperCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyPaperCommentFavoriteArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyPaperFavoriteArgs = {
  paperInput: PaperInput;
};


export type MutationDestroyTagFromPaperArgs = {
  name: Scalars['String'];
  paperInput: PaperInput;
};


export type MutationDestroyTagToSlackArgs = {
  channelName: Scalars['String'];
  tagName: Scalars['String'];
};


export type MutationUpdatePaperCommentArgs = {
  comment: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationUpdatePaperCommentFavoriteArgs = {
  id: Scalars['ID'];
};


export type MutationUpdatePaperFavoriteArgs = {
  paperInput: PaperInput;
};


export type MutationUpdatePaperUserStatusArgs = {
  paperInput: PaperInput;
  statusName: PaperUserStatusName;
};


export type MutationUpdateTagToSlackArgs = {
  channelName: Scalars['String'];
  tagName: Scalars['String'];
};

export type MyPaper = {
  __typename?: 'MyPaper';
  paperFavorite?: Maybe<PaperFavorite>;
  paperUserStatus?: Maybe<PaperUserStatus>;
};

export type Node = {
  id: Scalars['ID'];
};

export enum Paper_Source_Type {
  ArxivOrg = 'ARXIV_ORG',
  Biorxiv = 'BIORXIV',
  Chemrxiv = 'CHEMRXIV',
  Doi = 'DOI',
  Ieee = 'IEEE',
  Medrxiv = 'MEDRXIV',
  Openreview = 'OPENREVIEW',
  SemanticScholar = 'SEMANTIC_SCHOLAR'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

export type PagingInput = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};

export type Paper = {
  __typename?: 'Paper';
  abstract?: Maybe<Scalars['String']>;
  authors?: Maybe<Array<Scalars['String']>>;
  originalID: Scalars['String'];
  originalPDFURL: Scalars['String'];
  originalURL: Scalars['String'];
  source: Paper_Source_Type;
  title?: Maybe<Scalars['String']>;
  version: Scalars['String'];
};

export type PaperAccessLog = {
  __typename?: 'PaperAccessLog';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  /** @deprecated Use paperFull */
  paper: Paper;
  paperFull: PaperFull;
  user: User;
};

export type PaperComment = {
  __typename?: 'PaperComment';
  comment: Scalars['String'];
  createdAt: Scalars['Time'];
  favorites: Array<PaperCommentFavorite>;
  id: Scalars['ID'];
  /** @deprecated Use paperFull */
  paper: Paper;
  paperFull: PaperFull;
  user: User;
};

export type PaperCommentFavorite = {
  __typename?: 'PaperCommentFavorite';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  paperComment: PaperComment;
  user: User;
};

export type PaperCommentFavoriteConnection = {
  __typename?: 'PaperCommentFavoriteConnection';
  edge: Array<PaperCommentFavorite>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type PaperFavorite = {
  __typename?: 'PaperFavorite';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  /** @deprecated Use paperFull */
  paper: Paper;
  paperFull: PaperFull;
  user: User;
};

export type PaperFull = {
  __typename?: 'PaperFull';
  comments: Array<PaperComment>;
  favorites: Array<PaperFavorite>;
  isFavorite: Scalars['Boolean'];
  myComments: Array<PaperComment>;
  otherUserComments: Array<PaperComment>;
  /** @deprecated Use paperSources */
  paper: Paper;
  paperSources?: Maybe<Array<PaperSource>>;
  readLaterUsers: Array<PaperUserStatus>;
  readUsers: Array<PaperUserStatus>;
  status: PaperUserStatusName;
  tags: Array<PaperTag>;
};

export type PaperFullConnection = {
  __typename?: 'PaperFullConnection';
  edge: Array<PaperFull>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type PaperIdWithSource = {
  __typename?: 'PaperIDWithSource';
  originalID: Scalars['String'];
  source: Paper_Source_Type;
  version: Scalars['String'];
};

export type PaperInput = {
  originalID: Scalars['String'];
  source: Paper_Source_Type;
  version?: InputMaybe<Scalars['String']>;
};

export type PaperPayload = {
  __typename?: 'PaperPayload';
  originalID: Scalars['String'];
  source: Paper_Source_Type;
  version: Scalars['String'];
};

export type PaperRead = {
  __typename?: 'PaperRead';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  paper: Paper;
  user: User;
};

export type PaperSource = {
  __typename?: 'PaperSource';
  abstract?: Maybe<Scalars['String']>;
  authors?: Maybe<Array<Scalars['String']>>;
  originalID: Scalars['String'];
  originalPDFURL: Scalars['String'];
  originalURL: Scalars['String'];
  source: Paper_Source_Type;
  title?: Maybe<Scalars['String']>;
  version: Scalars['String'];
};

export type PaperTag = {
  __typename?: 'PaperTag';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PaperTagConnection = {
  __typename?: 'PaperTagConnection';
  edge: Array<PaperTag>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type PaperUserStatus = {
  __typename?: 'PaperUserStatus';
  changedAt: Scalars['Time'];
  id: Scalars['ID'];
  /** @deprecated Use paperFull */
  paper: Paper;
  paperFull: PaperFull;
  status: PaperUserStatusName;
  user: User;
};

export enum PaperUserStatusName {
  PaperUserStatusRead = 'PAPER_USER_STATUS_READ',
  PaperUserStatusReadLater = 'PAPER_USER_STATUS_READ_LATER',
  PaperUserStatusUnKnown = 'PAPER_USER_STATUS_UN_KNOWN',
  PaperUserStatusUnRead = 'PAPER_USER_STATUS_UN_READ'
}

export type Query = {
  __typename?: 'Query';
  allComments: CommentConnection;
  allReadLaterPapers: ReadPaperConnection;
  allReadPapers: ReadPaperConnection;
  findPaperFromSemanticScholarID: PaperIdWithSource;
  me: Me;
  node: Node;
  paper: PaperFull;
  paperComment: PaperComment;
  searchUsers: Array<UserPublic>;
  tag: Tag;
  tagNamesByPrefix: Array<Scalars['String']>;
  user: UserPublic;
  weeklyRankings: WeeklyRankingConnection;
};


export type QueryAllCommentsArgs = {
  pagingInput: PagingInput;
};


export type QueryAllReadLaterPapersArgs = {
  pagingInput: PagingInput;
};


export type QueryAllReadPapersArgs = {
  pagingInput: PagingInput;
};


export type QueryFindPaperFromSemanticScholarIdArgs = {
  id: Scalars['ID'];
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryPaperArgs = {
  paperInput: PaperInput;
};


export type QueryPaperCommentArgs = {
  id: Scalars['ID'];
};


export type QuerySearchUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QueryTagArgs = {
  name: Scalars['String'];
};


export type QueryTagNamesByPrefixArgs = {
  prefix: Scalars['String'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryWeeklyRankingsArgs = {
  pagingInput: PagingInput;
};

export type ReadConnection = {
  __typename?: 'ReadConnection';
  edge: Array<PaperRead>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type ReadPaperConnection = {
  __typename?: 'ReadPaperConnection';
  edge: Array<PaperUserStatus>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type Tag = {
  __typename?: 'Tag';
  channels: Array<TagToSlack>;
  createdAt: Scalars['Time'];
  events: TagEventConnection;
  id: Scalars['ID'];
  name: Scalars['String'];
  papers: PaperFullConnection;
};


export type TagEventsArgs = {
  pagingInput: PagingInput;
};


export type TagPapersArgs = {
  pagingInput: PagingInput;
};

export type TagEvent = {
  __typename?: 'TagEvent';
  event: TagEventType;
  occurredAt: Scalars['Time'];
  paper: PaperFull;
  user: User;
};

export type TagEventConnection = {
  __typename?: 'TagEventConnection';
  edge: Array<TagEvent>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export enum TagEventType {
  TagEventCreated = 'TAG_EVENT_CREATED',
  TagEventDeleted = 'TAG_EVENT_DELETED',
  TagEventUnknown = 'TAG_EVENT_UNKNOWN'
}

export type TagToSlack = {
  __typename?: 'TagToSlack';
  channelName: Scalars['String'];
};

export type UpdatePaperUserStatusPayload = {
  __typename?: 'UpdatePaperUserStatusPayload';
  paperUserStatus: PaperUserStatus;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  id: Scalars['ID'];
  userName: Scalars['String'];
};

export type UserNotification = {
  __typename?: 'UserNotification';
  id: Scalars['ID'];
  newCommentForPaper?: Maybe<PaperComment>;
  type: UserNotificationType;
};

export type UserNotificationConnection = {
  __typename?: 'UserNotificationConnection';
  edge: Array<UserNotification>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export enum UserNotificationType {
  NewCommentForPaper = 'NEW_COMMENT_FOR_PAPER'
}

export type UserPublic = {
  __typename?: 'UserPublic';
  comments: CommentConnection;
  favorites: FavoriteConnection;
  filterSearch: FilterSearchResult;
  profile: User;
  readLaterPapers: ReadPaperConnection;
  readPapers: ReadPaperConnection;
};


export type UserPublicCommentsArgs = {
  pagingInput: PagingInput;
};


export type UserPublicFavoritesArgs = {
  pagingInput: PagingInput;
};


export type UserPublicFilterSearchArgs = {
  filterSearchInput: FilterSearchInput;
  pagingInput: PagingInput;
};


export type UserPublicReadLaterPapersArgs = {
  pagingInput: PagingInput;
};


export type UserPublicReadPapersArgs = {
  pagingInput: PagingInput;
};

export type WeeklyRanking = {
  __typename?: 'WeeklyRanking';
  recordDate: Scalars['String'];
  records: Array<WeeklyRankingRecord>;
};

export type WeeklyRankingConnection = {
  __typename?: 'WeeklyRankingConnection';
  edge: Array<WeeklyRanking>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type WeeklyRankingRecord = {
  __typename?: 'WeeklyRankingRecord';
  order: Scalars['Int'];
  /** @deprecated Use paperFull */
  paper: Paper;
  paperFull: PaperFull;
  score: Scalars['Int'];
};

export type MutationPaperCommentPayload = {
  __typename?: 'mutationPaperCommentPayload';
  paperComment: PaperComment;
};

export type PaperTagPayload = {
  __typename?: 'paperTagPayload';
  paperTag: PaperTag;
};

export type UpdatePaperFavoritePayload = {
  __typename?: 'updatePaperFavoritePayload';
  paperFavorite: PaperFavorite;
};

export type UpdatePaperReadPayload = {
  __typename?: 'updatePaperReadPayload';
  paperRead: PaperRead;
};

export type AllCommentsQueryVariables = Exact<{
  pagingInput: PagingInput;
}>;


export type AllCommentsQuery = { __typename?: 'Query', allComments: { __typename?: 'CommentConnection', total: number, edge: Array<{ __typename?: 'PaperComment', id: string, comment: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }, favorites: Array<{ __typename?: 'PaperCommentFavorite', id: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string } }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type PaperCommentQueryVariables = Exact<{
  commentID: Scalars['ID'];
}>;


export type PaperCommentQuery = { __typename?: 'Query', paperComment: { __typename?: 'PaperComment', id: string, comment: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }, favorites: Array<{ __typename?: 'PaperCommentFavorite', id: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string } }> } };

export type MyAccessLogsQueryVariables = Exact<{
  pagingInput: PagingInput;
}>;


export type MyAccessLogsQuery = { __typename?: 'Query', me: { __typename?: 'Me', accessLogs: { __typename?: 'AccessLogConnection', total: number, edge: Array<{ __typename?: 'PaperAccessLog', id: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paperFull: { __typename?: 'PaperFull', tags: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }>, paperSources?: Array<{ __typename?: 'PaperSource', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type MyCommentsQueryVariables = Exact<{
  pagingInput: PagingInput;
}>;


export type MyCommentsQuery = { __typename?: 'Query', me: { __typename?: 'Me', comments: { __typename?: 'CommentConnection', total: number, edge: Array<{ __typename?: 'PaperComment', id: string, comment: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paperFull: { __typename?: 'PaperFull', tags: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }>, paperSources?: Array<{ __typename?: 'PaperSource', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }> | null }, favorites: Array<{ __typename?: 'PaperCommentFavorite', id: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string } }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type MyNotificationQueryVariables = Exact<{
  pagingInput: PagingInput;
}>;


export type MyNotificationQuery = { __typename?: 'Query', me: { __typename?: 'Me', notifications: { __typename?: 'UserNotificationConnection', total: number, edge: Array<{ __typename?: 'UserNotification', id: string, type: UserNotificationType, newCommentForPaper?: { __typename?: 'PaperComment', id: string, comment: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string }, paperFull: { __typename?: 'PaperFull', tags: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }>, paperSources?: Array<{ __typename?: 'PaperSource', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }> | null }, favorites: Array<{ __typename?: 'PaperCommentFavorite', id: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string } }> } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type MyTagsQueryVariables = Exact<{
  pagingInput: PagingInput;
}>;


export type MyTagsQuery = { __typename?: 'Query', me: { __typename?: 'Me', tags: { __typename?: 'PaperTagConnection', total: number, edge: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type CreatePaperAccessLogMutationVariables = Exact<{
  paperInput: PaperInput;
}>;


export type CreatePaperAccessLogMutation = { __typename?: 'Mutation', createPaperAccessLog: { __typename?: 'PaperPayload', source: Paper_Source_Type, originalID: string } };

export type CreatePaperCommentMutationVariables = Exact<{
  paperInput: PaperInput;
  comment: Scalars['String'];
}>;


export type CreatePaperCommentMutation = { __typename?: 'Mutation', createPaperComment: { __typename?: 'mutationPaperCommentPayload', paperComment: { __typename?: 'PaperComment', id: string } } };

export type UpdatePaperCommentMutationVariables = Exact<{
  commentID: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type UpdatePaperCommentMutation = { __typename?: 'Mutation', updatePaperComment: { __typename?: 'mutationPaperCommentPayload', paperComment: { __typename?: 'PaperComment', id: string } } };

export type DeletePaperCommentMutationVariables = Exact<{
  commentID: Scalars['ID'];
}>;


export type DeletePaperCommentMutation = { __typename?: 'Mutation', destroyPaperComment: { __typename?: 'mutationPaperCommentPayload', paperComment: { __typename?: 'PaperComment', id: string } } };

export type UpdatePaperCommentFavoriteMutationVariables = Exact<{
  commentID: Scalars['ID'];
}>;


export type UpdatePaperCommentFavoriteMutation = { __typename?: 'Mutation', updatePaperCommentFavorite: { __typename?: 'PaperCommentFavorite', paperComment: { __typename?: 'PaperComment', id: string } } };

export type DeletePaperCommentFavoriteMutationVariables = Exact<{
  commentID: Scalars['ID'];
}>;


export type DeletePaperCommentFavoriteMutation = { __typename?: 'Mutation', destroyPaperCommentFavorite: { __typename?: 'PaperCommentFavorite', paperComment: { __typename?: 'PaperComment', id: string } } };

export type UpdatePaperFavoriteMutationVariables = Exact<{
  paperInput: PaperInput;
}>;


export type UpdatePaperFavoriteMutation = { __typename?: 'Mutation', updatePaperFavorite: { __typename?: 'updatePaperFavoritePayload', paperFavorite: { __typename?: 'PaperFavorite', id: string, createdAt: Time } } };

export type DestroyPaperFavoriteMutationVariables = Exact<{
  paperInput: PaperInput;
}>;


export type DestroyPaperFavoriteMutation = { __typename?: 'Mutation', destroyPaperFavorite: { __typename?: 'PaperPayload', source: Paper_Source_Type, originalID: string } };

export type UpdatePaperUserStatusMutationVariables = Exact<{
  paperInput: PaperInput;
  statusName: PaperUserStatusName;
}>;


export type UpdatePaperUserStatusMutation = { __typename?: 'Mutation', updatePaperUserStatus: { __typename?: 'UpdatePaperUserStatusPayload', paperUserStatus: { __typename?: 'PaperUserStatus', id: string, changedAt: Time, status: PaperUserStatusName } } };

export type CreatePaperTagMutationVariables = Exact<{
  paperInput: PaperInput;
  name: Scalars['String'];
}>;


export type CreatePaperTagMutation = { __typename?: 'Mutation', createPaperTag: { __typename?: 'paperTagPayload', paperTag: { __typename?: 'PaperTag', id: string, name: string, createdAt: Time } } };

export type DeletePaperTagMutationVariables = Exact<{
  name: Scalars['String'];
  paperInput: PaperInput;
}>;


export type DeletePaperTagMutation = { __typename?: 'Mutation', destroyTagFromPaper: { __typename?: 'PaperPayload', source: Paper_Source_Type, originalID: string, version: string } };

export type UpdateTagToSlackMutationVariables = Exact<{
  name: Scalars['String'];
  channel: Scalars['String'];
}>;


export type UpdateTagToSlackMutation = { __typename?: 'Mutation', updateTagToSlack?: { __typename?: 'Tag', id: string, name: string, createdAt: Time } | null };

export type DeleteTagToSlackMutationVariables = Exact<{
  name: Scalars['String'];
  channel: Scalars['String'];
}>;


export type DeleteTagToSlackMutation = { __typename?: 'Mutation', destroyTagToSlack?: { __typename?: 'Tag', id: string, name: string, createdAt: Time } | null };

export type PaperQueryVariables = Exact<{
  paperInput: PaperInput;
}>;


export type PaperQuery = { __typename?: 'Query', paper: { __typename?: 'PaperFull', status: PaperUserStatusName, isFavorite: boolean, paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }, comments: Array<{ __typename?: 'PaperComment', id: string, comment: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }, favorites: Array<{ __typename?: 'PaperCommentFavorite', id: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string } }> }>, favorites: Array<{ __typename?: 'PaperFavorite', id: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null } }>, readUsers: Array<{ __typename?: 'PaperUserStatus', id: string, changedAt: Time, status: PaperUserStatusName, user: { __typename?: 'User', id: string, email: string, userName: string }, paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null } }>, readLaterUsers: Array<{ __typename?: 'PaperUserStatus', id: string, changedAt: Time, status: PaperUserStatusName, user: { __typename?: 'User', id: string, email: string, userName: string }, paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null } }>, tags: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }> } };

export type FindPaperFromSemanticScholarIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FindPaperFromSemanticScholarIdQuery = { __typename?: 'Query', findPaperFromSemanticScholarID: { __typename?: 'PaperIDWithSource', source: Paper_Source_Type, originalID: string, version: string } };

export type WeeklyRankingsQueryVariables = Exact<{
  pagingInput: PagingInput;
}>;


export type WeeklyRankingsQuery = { __typename?: 'Query', weeklyRankings: { __typename?: 'WeeklyRankingConnection', total: number, edge: Array<{ __typename?: 'WeeklyRanking', recordDate: string, records: Array<{ __typename?: 'WeeklyRankingRecord', order: number, score: number, paperFull: { __typename?: 'PaperFull', tags: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }>, paperSources?: Array<{ __typename?: 'PaperSource', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }> | null } }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type SearchUsersQueryVariables = Exact<{
  query: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'UserPublic', profile: { __typename?: 'User', id: string, userName: string } }> };

export type TagPapersQueryVariables = Exact<{
  name: Scalars['String'];
  pagingInput: PagingInput;
  eventsPagingInput?: InputMaybe<PagingInput>;
}>;


export type TagPapersQuery = { __typename?: 'Query', tag: { __typename?: 'Tag', id: string, name: string, createdAt: Time, papers: { __typename?: 'PaperFullConnection', total: number, edge: Array<{ __typename?: 'PaperFull', paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }, tags: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } }, events: { __typename?: 'TagEventConnection', total: number, edge: Array<{ __typename?: 'TagEvent', event: TagEventType, occurredAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paper: { __typename?: 'PaperFull', paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } }, channels: Array<{ __typename?: 'TagToSlack', channelName: string }> } };

export type TagNameByPrefixQueryVariables = Exact<{
  prefix: Scalars['String'];
}>;


export type TagNameByPrefixQuery = { __typename?: 'Query', tagNamesByPrefix: Array<string> };

export type UserCommentsQueryVariables = Exact<{
  pagingInput: PagingInput;
  id: Scalars['ID'];
}>;


export type UserCommentsQuery = { __typename?: 'Query', user: { __typename?: 'UserPublic', comments: { __typename?: 'CommentConnection', total: number, edge: Array<{ __typename?: 'PaperComment', id: string, comment: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paper: { __typename?: 'Paper', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }, favorites: Array<{ __typename?: 'PaperCommentFavorite', id: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string } }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type UserFavoritesQueryVariables = Exact<{
  pagingInput: PagingInput;
  id: Scalars['ID'];
}>;


export type UserFavoritesQuery = { __typename?: 'Query', user: { __typename?: 'UserPublic', favorites: { __typename?: 'FavoriteConnection', total: number, edge: Array<{ __typename?: 'PaperFavorite', id: string, createdAt: Time, user: { __typename?: 'User', id: string, email: string, userName: string }, paperFull: { __typename?: 'PaperFull', tags: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }>, paperSources?: Array<{ __typename?: 'PaperSource', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type UserReadsQueryVariables = Exact<{
  pagingInput: PagingInput;
  id: Scalars['ID'];
}>;


export type UserReadsQuery = { __typename?: 'Query', user: { __typename?: 'UserPublic', readPapers: { __typename?: 'ReadPaperConnection', total: number, edge: Array<{ __typename?: 'PaperUserStatus', id: string, changedAt: Time, status: PaperUserStatusName, user: { __typename?: 'User', id: string, email: string, userName: string }, paperFull: { __typename?: 'PaperFull', tags: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }>, paperSources?: Array<{ __typename?: 'PaperSource', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type UserReadLatersQueryVariables = Exact<{
  pagingInput: PagingInput;
  id: Scalars['ID'];
}>;


export type UserReadLatersQuery = { __typename?: 'Query', user: { __typename?: 'UserPublic', readLaterPapers: { __typename?: 'ReadPaperConnection', total: number, edge: Array<{ __typename?: 'PaperUserStatus', id: string, changedAt: Time, status: PaperUserStatusName, user: { __typename?: 'User', id: string, email: string, userName: string }, paperFull: { __typename?: 'PaperFull', tags: Array<{ __typename?: 'PaperTag', id: string, name: string, createdAt: Time }>, paperSources?: Array<{ __typename?: 'PaperSource', source: Paper_Source_Type, originalID: string, version: string, originalURL: string, originalPDFURL: string, title?: string | null, abstract?: string | null, authors?: Array<string> | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type UserProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserProfileQuery = { __typename?: 'Query', user: { __typename?: 'UserPublic', profile: { __typename?: 'User', id: string, email: string, userName: string }, comments: { __typename?: 'CommentConnection', total: number }, favorites: { __typename?: 'FavoriteConnection', total: number }, readPapers: { __typename?: 'ReadPaperConnection', total: number }, readLaterPapers: { __typename?: 'ReadPaperConnection', total: number } } };

export type UserStatsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserStatsQuery = { __typename?: 'Query', user: { __typename?: 'UserPublic', comments: { __typename?: 'CommentConnection', edge: Array<{ __typename?: 'PaperComment', createdAt: Time }> }, favorites: { __typename?: 'FavoriteConnection', edge: Array<{ __typename?: 'PaperFavorite', createdAt: Time }> }, readPapers: { __typename?: 'ReadPaperConnection', edge: Array<{ __typename?: 'PaperUserStatus', changedAt: Time }> }, readLaterPapers: { __typename?: 'ReadPaperConnection', edge: Array<{ __typename?: 'PaperUserStatus', changedAt: Time }> } } };


export const AllCommentsDocument = gql`
    query AllComments($pagingInput: PagingInput!) {
  allComments(pagingInput: $pagingInput) {
    edge {
      id
      comment
      createdAt
      user {
        id
        email
        userName
      }
      paper {
        source
        originalID
        version
        originalURL
        originalPDFURL
        title
        abstract
        authors
      }
      favorites {
        id
        createdAt
        user {
          id
          email
          userName
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    total
  }
}
    `;

/**
 * __useAllCommentsQuery__
 *
 * To run a query within a React component, call `useAllCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCommentsQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useAllCommentsQuery(baseOptions: Apollo.QueryHookOptions<AllCommentsQuery, AllCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCommentsQuery, AllCommentsQueryVariables>(AllCommentsDocument, options);
      }
export function useAllCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCommentsQuery, AllCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCommentsQuery, AllCommentsQueryVariables>(AllCommentsDocument, options);
        }
export type AllCommentsQueryHookResult = ReturnType<typeof useAllCommentsQuery>;
export type AllCommentsLazyQueryHookResult = ReturnType<typeof useAllCommentsLazyQuery>;
export type AllCommentsQueryResult = Apollo.QueryResult<AllCommentsQuery, AllCommentsQueryVariables>;
export const PaperCommentDocument = gql`
    query PaperComment($commentID: ID!) {
  paperComment(id: $commentID) {
    id
    comment
    createdAt
    user {
      id
      email
      userName
    }
    paper {
      source
      originalID
      version
      originalURL
      originalPDFURL
      title
      abstract
      authors
    }
    favorites {
      id
      createdAt
      user {
        id
        email
        userName
      }
    }
  }
}
    `;

/**
 * __usePaperCommentQuery__
 *
 * To run a query within a React component, call `usePaperCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaperCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaperCommentQuery({
 *   variables: {
 *      commentID: // value for 'commentID'
 *   },
 * });
 */
export function usePaperCommentQuery(baseOptions: Apollo.QueryHookOptions<PaperCommentQuery, PaperCommentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaperCommentQuery, PaperCommentQueryVariables>(PaperCommentDocument, options);
      }
export function usePaperCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaperCommentQuery, PaperCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaperCommentQuery, PaperCommentQueryVariables>(PaperCommentDocument, options);
        }
export type PaperCommentQueryHookResult = ReturnType<typeof usePaperCommentQuery>;
export type PaperCommentLazyQueryHookResult = ReturnType<typeof usePaperCommentLazyQuery>;
export type PaperCommentQueryResult = Apollo.QueryResult<PaperCommentQuery, PaperCommentQueryVariables>;
export const MyAccessLogsDocument = gql`
    query MyAccessLogs($pagingInput: PagingInput!) {
  me {
    accessLogs(pagingInput: $pagingInput) {
      edge {
        id
        createdAt
        user {
          id
          email
          userName
        }
        paperFull {
          tags {
            id
            name
            createdAt
          }
          paperSources {
            source
            originalID
            version
            originalURL
            originalPDFURL
            title
            abstract
            authors
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
  }
}
    `;

/**
 * __useMyAccessLogsQuery__
 *
 * To run a query within a React component, call `useMyAccessLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccessLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccessLogsQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useMyAccessLogsQuery(baseOptions: Apollo.QueryHookOptions<MyAccessLogsQuery, MyAccessLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccessLogsQuery, MyAccessLogsQueryVariables>(MyAccessLogsDocument, options);
      }
export function useMyAccessLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccessLogsQuery, MyAccessLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccessLogsQuery, MyAccessLogsQueryVariables>(MyAccessLogsDocument, options);
        }
export type MyAccessLogsQueryHookResult = ReturnType<typeof useMyAccessLogsQuery>;
export type MyAccessLogsLazyQueryHookResult = ReturnType<typeof useMyAccessLogsLazyQuery>;
export type MyAccessLogsQueryResult = Apollo.QueryResult<MyAccessLogsQuery, MyAccessLogsQueryVariables>;
export const MyCommentsDocument = gql`
    query MyComments($pagingInput: PagingInput!) {
  me {
    comments(pagingInput: $pagingInput) {
      edge {
        id
        comment
        createdAt
        user {
          id
          email
          userName
        }
        paperFull {
          tags {
            id
            name
            createdAt
          }
          paperSources {
            source
            originalID
            version
            originalURL
            originalPDFURL
            title
            abstract
            authors
          }
        }
        favorites {
          id
          createdAt
          user {
            id
            email
            userName
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
  }
}
    `;

/**
 * __useMyCommentsQuery__
 *
 * To run a query within a React component, call `useMyCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCommentsQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useMyCommentsQuery(baseOptions: Apollo.QueryHookOptions<MyCommentsQuery, MyCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCommentsQuery, MyCommentsQueryVariables>(MyCommentsDocument, options);
      }
export function useMyCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCommentsQuery, MyCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCommentsQuery, MyCommentsQueryVariables>(MyCommentsDocument, options);
        }
export type MyCommentsQueryHookResult = ReturnType<typeof useMyCommentsQuery>;
export type MyCommentsLazyQueryHookResult = ReturnType<typeof useMyCommentsLazyQuery>;
export type MyCommentsQueryResult = Apollo.QueryResult<MyCommentsQuery, MyCommentsQueryVariables>;
export const MyNotificationDocument = gql`
    query MyNotification($pagingInput: PagingInput!) {
  me {
    notifications(pagingInput: $pagingInput) {
      edge {
        id
        type
        newCommentForPaper {
          id
          comment
          createdAt
          user {
            id
            email
            userName
          }
          paper {
            source
            originalID
            version
            originalURL
            originalPDFURL
          }
          paperFull {
            tags {
              id
              name
              createdAt
            }
            paperSources {
              source
              originalID
              version
              originalURL
              originalPDFURL
              title
              abstract
              authors
            }
          }
          favorites {
            id
            createdAt
            user {
              id
              email
              userName
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
  }
}
    `;

/**
 * __useMyNotificationQuery__
 *
 * To run a query within a React component, call `useMyNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyNotificationQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useMyNotificationQuery(baseOptions: Apollo.QueryHookOptions<MyNotificationQuery, MyNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyNotificationQuery, MyNotificationQueryVariables>(MyNotificationDocument, options);
      }
export function useMyNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyNotificationQuery, MyNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyNotificationQuery, MyNotificationQueryVariables>(MyNotificationDocument, options);
        }
export type MyNotificationQueryHookResult = ReturnType<typeof useMyNotificationQuery>;
export type MyNotificationLazyQueryHookResult = ReturnType<typeof useMyNotificationLazyQuery>;
export type MyNotificationQueryResult = Apollo.QueryResult<MyNotificationQuery, MyNotificationQueryVariables>;
export const MyTagsDocument = gql`
    query MyTags($pagingInput: PagingInput!) {
  me {
    tags(pagingInput: $pagingInput) {
      edge {
        id
        name
        createdAt
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
  }
}
    `;

/**
 * __useMyTagsQuery__
 *
 * To run a query within a React component, call `useMyTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTagsQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useMyTagsQuery(baseOptions: Apollo.QueryHookOptions<MyTagsQuery, MyTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTagsQuery, MyTagsQueryVariables>(MyTagsDocument, options);
      }
export function useMyTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTagsQuery, MyTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTagsQuery, MyTagsQueryVariables>(MyTagsDocument, options);
        }
export type MyTagsQueryHookResult = ReturnType<typeof useMyTagsQuery>;
export type MyTagsLazyQueryHookResult = ReturnType<typeof useMyTagsLazyQuery>;
export type MyTagsQueryResult = Apollo.QueryResult<MyTagsQuery, MyTagsQueryVariables>;
export const CreatePaperAccessLogDocument = gql`
    mutation createPaperAccessLog($paperInput: PaperInput!) {
  createPaperAccessLog(paperInput: $paperInput) {
    source
    originalID
  }
}
    `;
export type CreatePaperAccessLogMutationFn = Apollo.MutationFunction<CreatePaperAccessLogMutation, CreatePaperAccessLogMutationVariables>;

/**
 * __useCreatePaperAccessLogMutation__
 *
 * To run a mutation, you first call `useCreatePaperAccessLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaperAccessLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaperAccessLogMutation, { data, loading, error }] = useCreatePaperAccessLogMutation({
 *   variables: {
 *      paperInput: // value for 'paperInput'
 *   },
 * });
 */
export function useCreatePaperAccessLogMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaperAccessLogMutation, CreatePaperAccessLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaperAccessLogMutation, CreatePaperAccessLogMutationVariables>(CreatePaperAccessLogDocument, options);
      }
export type CreatePaperAccessLogMutationHookResult = ReturnType<typeof useCreatePaperAccessLogMutation>;
export type CreatePaperAccessLogMutationResult = Apollo.MutationResult<CreatePaperAccessLogMutation>;
export type CreatePaperAccessLogMutationOptions = Apollo.BaseMutationOptions<CreatePaperAccessLogMutation, CreatePaperAccessLogMutationVariables>;
export const CreatePaperCommentDocument = gql`
    mutation createPaperComment($paperInput: PaperInput!, $comment: String!) {
  createPaperComment(paperInput: $paperInput, comment: $comment) {
    paperComment {
      id
    }
  }
}
    `;
export type CreatePaperCommentMutationFn = Apollo.MutationFunction<CreatePaperCommentMutation, CreatePaperCommentMutationVariables>;

/**
 * __useCreatePaperCommentMutation__
 *
 * To run a mutation, you first call `useCreatePaperCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaperCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaperCommentMutation, { data, loading, error }] = useCreatePaperCommentMutation({
 *   variables: {
 *      paperInput: // value for 'paperInput'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreatePaperCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaperCommentMutation, CreatePaperCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaperCommentMutation, CreatePaperCommentMutationVariables>(CreatePaperCommentDocument, options);
      }
export type CreatePaperCommentMutationHookResult = ReturnType<typeof useCreatePaperCommentMutation>;
export type CreatePaperCommentMutationResult = Apollo.MutationResult<CreatePaperCommentMutation>;
export type CreatePaperCommentMutationOptions = Apollo.BaseMutationOptions<CreatePaperCommentMutation, CreatePaperCommentMutationVariables>;
export const UpdatePaperCommentDocument = gql`
    mutation updatePaperComment($commentID: ID!, $comment: String!) {
  updatePaperComment(id: $commentID, comment: $comment) {
    paperComment {
      id
    }
  }
}
    `;
export type UpdatePaperCommentMutationFn = Apollo.MutationFunction<UpdatePaperCommentMutation, UpdatePaperCommentMutationVariables>;

/**
 * __useUpdatePaperCommentMutation__
 *
 * To run a mutation, you first call `useUpdatePaperCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaperCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaperCommentMutation, { data, loading, error }] = useUpdatePaperCommentMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdatePaperCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaperCommentMutation, UpdatePaperCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaperCommentMutation, UpdatePaperCommentMutationVariables>(UpdatePaperCommentDocument, options);
      }
export type UpdatePaperCommentMutationHookResult = ReturnType<typeof useUpdatePaperCommentMutation>;
export type UpdatePaperCommentMutationResult = Apollo.MutationResult<UpdatePaperCommentMutation>;
export type UpdatePaperCommentMutationOptions = Apollo.BaseMutationOptions<UpdatePaperCommentMutation, UpdatePaperCommentMutationVariables>;
export const DeletePaperCommentDocument = gql`
    mutation DeletePaperComment($commentID: ID!) {
  destroyPaperComment(id: $commentID) {
    paperComment {
      id
    }
  }
}
    `;
export type DeletePaperCommentMutationFn = Apollo.MutationFunction<DeletePaperCommentMutation, DeletePaperCommentMutationVariables>;

/**
 * __useDeletePaperCommentMutation__
 *
 * To run a mutation, you first call `useDeletePaperCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaperCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaperCommentMutation, { data, loading, error }] = useDeletePaperCommentMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *   },
 * });
 */
export function useDeletePaperCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaperCommentMutation, DeletePaperCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaperCommentMutation, DeletePaperCommentMutationVariables>(DeletePaperCommentDocument, options);
      }
export type DeletePaperCommentMutationHookResult = ReturnType<typeof useDeletePaperCommentMutation>;
export type DeletePaperCommentMutationResult = Apollo.MutationResult<DeletePaperCommentMutation>;
export type DeletePaperCommentMutationOptions = Apollo.BaseMutationOptions<DeletePaperCommentMutation, DeletePaperCommentMutationVariables>;
export const UpdatePaperCommentFavoriteDocument = gql`
    mutation updatePaperCommentFavorite($commentID: ID!) {
  updatePaperCommentFavorite(id: $commentID) {
    paperComment {
      id
    }
  }
}
    `;
export type UpdatePaperCommentFavoriteMutationFn = Apollo.MutationFunction<UpdatePaperCommentFavoriteMutation, UpdatePaperCommentFavoriteMutationVariables>;

/**
 * __useUpdatePaperCommentFavoriteMutation__
 *
 * To run a mutation, you first call `useUpdatePaperCommentFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaperCommentFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaperCommentFavoriteMutation, { data, loading, error }] = useUpdatePaperCommentFavoriteMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *   },
 * });
 */
export function useUpdatePaperCommentFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaperCommentFavoriteMutation, UpdatePaperCommentFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaperCommentFavoriteMutation, UpdatePaperCommentFavoriteMutationVariables>(UpdatePaperCommentFavoriteDocument, options);
      }
export type UpdatePaperCommentFavoriteMutationHookResult = ReturnType<typeof useUpdatePaperCommentFavoriteMutation>;
export type UpdatePaperCommentFavoriteMutationResult = Apollo.MutationResult<UpdatePaperCommentFavoriteMutation>;
export type UpdatePaperCommentFavoriteMutationOptions = Apollo.BaseMutationOptions<UpdatePaperCommentFavoriteMutation, UpdatePaperCommentFavoriteMutationVariables>;
export const DeletePaperCommentFavoriteDocument = gql`
    mutation DeletePaperCommentFavorite($commentID: ID!) {
  destroyPaperCommentFavorite(id: $commentID) {
    paperComment {
      id
    }
  }
}
    `;
export type DeletePaperCommentFavoriteMutationFn = Apollo.MutationFunction<DeletePaperCommentFavoriteMutation, DeletePaperCommentFavoriteMutationVariables>;

/**
 * __useDeletePaperCommentFavoriteMutation__
 *
 * To run a mutation, you first call `useDeletePaperCommentFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaperCommentFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaperCommentFavoriteMutation, { data, loading, error }] = useDeletePaperCommentFavoriteMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *   },
 * });
 */
export function useDeletePaperCommentFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaperCommentFavoriteMutation, DeletePaperCommentFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaperCommentFavoriteMutation, DeletePaperCommentFavoriteMutationVariables>(DeletePaperCommentFavoriteDocument, options);
      }
export type DeletePaperCommentFavoriteMutationHookResult = ReturnType<typeof useDeletePaperCommentFavoriteMutation>;
export type DeletePaperCommentFavoriteMutationResult = Apollo.MutationResult<DeletePaperCommentFavoriteMutation>;
export type DeletePaperCommentFavoriteMutationOptions = Apollo.BaseMutationOptions<DeletePaperCommentFavoriteMutation, DeletePaperCommentFavoriteMutationVariables>;
export const UpdatePaperFavoriteDocument = gql`
    mutation UpdatePaperFavorite($paperInput: PaperInput!) {
  updatePaperFavorite(paperInput: $paperInput) {
    paperFavorite {
      id
      createdAt
    }
  }
}
    `;
export type UpdatePaperFavoriteMutationFn = Apollo.MutationFunction<UpdatePaperFavoriteMutation, UpdatePaperFavoriteMutationVariables>;

/**
 * __useUpdatePaperFavoriteMutation__
 *
 * To run a mutation, you first call `useUpdatePaperFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaperFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaperFavoriteMutation, { data, loading, error }] = useUpdatePaperFavoriteMutation({
 *   variables: {
 *      paperInput: // value for 'paperInput'
 *   },
 * });
 */
export function useUpdatePaperFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaperFavoriteMutation, UpdatePaperFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaperFavoriteMutation, UpdatePaperFavoriteMutationVariables>(UpdatePaperFavoriteDocument, options);
      }
export type UpdatePaperFavoriteMutationHookResult = ReturnType<typeof useUpdatePaperFavoriteMutation>;
export type UpdatePaperFavoriteMutationResult = Apollo.MutationResult<UpdatePaperFavoriteMutation>;
export type UpdatePaperFavoriteMutationOptions = Apollo.BaseMutationOptions<UpdatePaperFavoriteMutation, UpdatePaperFavoriteMutationVariables>;
export const DestroyPaperFavoriteDocument = gql`
    mutation DestroyPaperFavorite($paperInput: PaperInput!) {
  destroyPaperFavorite(paperInput: $paperInput) {
    source
    originalID
  }
}
    `;
export type DestroyPaperFavoriteMutationFn = Apollo.MutationFunction<DestroyPaperFavoriteMutation, DestroyPaperFavoriteMutationVariables>;

/**
 * __useDestroyPaperFavoriteMutation__
 *
 * To run a mutation, you first call `useDestroyPaperFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyPaperFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyPaperFavoriteMutation, { data, loading, error }] = useDestroyPaperFavoriteMutation({
 *   variables: {
 *      paperInput: // value for 'paperInput'
 *   },
 * });
 */
export function useDestroyPaperFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<DestroyPaperFavoriteMutation, DestroyPaperFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyPaperFavoriteMutation, DestroyPaperFavoriteMutationVariables>(DestroyPaperFavoriteDocument, options);
      }
export type DestroyPaperFavoriteMutationHookResult = ReturnType<typeof useDestroyPaperFavoriteMutation>;
export type DestroyPaperFavoriteMutationResult = Apollo.MutationResult<DestroyPaperFavoriteMutation>;
export type DestroyPaperFavoriteMutationOptions = Apollo.BaseMutationOptions<DestroyPaperFavoriteMutation, DestroyPaperFavoriteMutationVariables>;
export const UpdatePaperUserStatusDocument = gql`
    mutation UpdatePaperUserStatus($paperInput: PaperInput!, $statusName: PaperUserStatusName!) {
  updatePaperUserStatus(paperInput: $paperInput, statusName: $statusName) {
    paperUserStatus {
      id
      changedAt
      status
    }
  }
}
    `;
export type UpdatePaperUserStatusMutationFn = Apollo.MutationFunction<UpdatePaperUserStatusMutation, UpdatePaperUserStatusMutationVariables>;

/**
 * __useUpdatePaperUserStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePaperUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaperUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaperUserStatusMutation, { data, loading, error }] = useUpdatePaperUserStatusMutation({
 *   variables: {
 *      paperInput: // value for 'paperInput'
 *      statusName: // value for 'statusName'
 *   },
 * });
 */
export function useUpdatePaperUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaperUserStatusMutation, UpdatePaperUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaperUserStatusMutation, UpdatePaperUserStatusMutationVariables>(UpdatePaperUserStatusDocument, options);
      }
export type UpdatePaperUserStatusMutationHookResult = ReturnType<typeof useUpdatePaperUserStatusMutation>;
export type UpdatePaperUserStatusMutationResult = Apollo.MutationResult<UpdatePaperUserStatusMutation>;
export type UpdatePaperUserStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePaperUserStatusMutation, UpdatePaperUserStatusMutationVariables>;
export const CreatePaperTagDocument = gql`
    mutation CreatePaperTag($paperInput: PaperInput!, $name: String!) {
  createPaperTag(paperInput: $paperInput, name: $name) {
    paperTag {
      id
      name
      createdAt
    }
  }
}
    `;
export type CreatePaperTagMutationFn = Apollo.MutationFunction<CreatePaperTagMutation, CreatePaperTagMutationVariables>;

/**
 * __useCreatePaperTagMutation__
 *
 * To run a mutation, you first call `useCreatePaperTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaperTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaperTagMutation, { data, loading, error }] = useCreatePaperTagMutation({
 *   variables: {
 *      paperInput: // value for 'paperInput'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreatePaperTagMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaperTagMutation, CreatePaperTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaperTagMutation, CreatePaperTagMutationVariables>(CreatePaperTagDocument, options);
      }
export type CreatePaperTagMutationHookResult = ReturnType<typeof useCreatePaperTagMutation>;
export type CreatePaperTagMutationResult = Apollo.MutationResult<CreatePaperTagMutation>;
export type CreatePaperTagMutationOptions = Apollo.BaseMutationOptions<CreatePaperTagMutation, CreatePaperTagMutationVariables>;
export const DeletePaperTagDocument = gql`
    mutation DeletePaperTag($name: String!, $paperInput: PaperInput!) {
  destroyTagFromPaper(paperInput: $paperInput, name: $name) {
    source
    originalID
    version
  }
}
    `;
export type DeletePaperTagMutationFn = Apollo.MutationFunction<DeletePaperTagMutation, DeletePaperTagMutationVariables>;

/**
 * __useDeletePaperTagMutation__
 *
 * To run a mutation, you first call `useDeletePaperTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaperTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaperTagMutation, { data, loading, error }] = useDeletePaperTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *      paperInput: // value for 'paperInput'
 *   },
 * });
 */
export function useDeletePaperTagMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaperTagMutation, DeletePaperTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaperTagMutation, DeletePaperTagMutationVariables>(DeletePaperTagDocument, options);
      }
export type DeletePaperTagMutationHookResult = ReturnType<typeof useDeletePaperTagMutation>;
export type DeletePaperTagMutationResult = Apollo.MutationResult<DeletePaperTagMutation>;
export type DeletePaperTagMutationOptions = Apollo.BaseMutationOptions<DeletePaperTagMutation, DeletePaperTagMutationVariables>;
export const UpdateTagToSlackDocument = gql`
    mutation UpdateTagToSlack($name: String!, $channel: String!) {
  updateTagToSlack(tagName: $name, channelName: $channel) {
    id
    name
    createdAt
  }
}
    `;
export type UpdateTagToSlackMutationFn = Apollo.MutationFunction<UpdateTagToSlackMutation, UpdateTagToSlackMutationVariables>;

/**
 * __useUpdateTagToSlackMutation__
 *
 * To run a mutation, you first call `useUpdateTagToSlackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagToSlackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagToSlackMutation, { data, loading, error }] = useUpdateTagToSlackMutation({
 *   variables: {
 *      name: // value for 'name'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useUpdateTagToSlackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagToSlackMutation, UpdateTagToSlackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagToSlackMutation, UpdateTagToSlackMutationVariables>(UpdateTagToSlackDocument, options);
      }
export type UpdateTagToSlackMutationHookResult = ReturnType<typeof useUpdateTagToSlackMutation>;
export type UpdateTagToSlackMutationResult = Apollo.MutationResult<UpdateTagToSlackMutation>;
export type UpdateTagToSlackMutationOptions = Apollo.BaseMutationOptions<UpdateTagToSlackMutation, UpdateTagToSlackMutationVariables>;
export const DeleteTagToSlackDocument = gql`
    mutation DeleteTagToSlack($name: String!, $channel: String!) {
  destroyTagToSlack(tagName: $name, channelName: $channel) {
    id
    name
    createdAt
  }
}
    `;
export type DeleteTagToSlackMutationFn = Apollo.MutationFunction<DeleteTagToSlackMutation, DeleteTagToSlackMutationVariables>;

/**
 * __useDeleteTagToSlackMutation__
 *
 * To run a mutation, you first call `useDeleteTagToSlackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagToSlackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagToSlackMutation, { data, loading, error }] = useDeleteTagToSlackMutation({
 *   variables: {
 *      name: // value for 'name'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useDeleteTagToSlackMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagToSlackMutation, DeleteTagToSlackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagToSlackMutation, DeleteTagToSlackMutationVariables>(DeleteTagToSlackDocument, options);
      }
export type DeleteTagToSlackMutationHookResult = ReturnType<typeof useDeleteTagToSlackMutation>;
export type DeleteTagToSlackMutationResult = Apollo.MutationResult<DeleteTagToSlackMutation>;
export type DeleteTagToSlackMutationOptions = Apollo.BaseMutationOptions<DeleteTagToSlackMutation, DeleteTagToSlackMutationVariables>;
export const PaperDocument = gql`
    query Paper($paperInput: PaperInput!) {
  paper(paperInput: $paperInput) {
    paper {
      source
      originalID
      version
      originalURL
      originalPDFURL
      title
      abstract
      authors
    }
    comments {
      id
      comment
      createdAt
      user {
        id
        email
        userName
      }
      paper {
        source
        originalID
        version
        originalURL
        originalPDFURL
        title
        abstract
        authors
      }
      favorites {
        id
        createdAt
        user {
          id
          email
          userName
        }
      }
    }
    favorites {
      id
      createdAt
      user {
        id
        email
        userName
      }
      paper {
        source
        originalID
        version
        originalURL
        originalPDFURL
        title
        abstract
        authors
      }
    }
    readUsers {
      id
      changedAt
      status
      user {
        id
        email
        userName
      }
      paper {
        source
        originalID
        version
        originalURL
        originalPDFURL
        title
        abstract
        authors
      }
    }
    readLaterUsers {
      id
      changedAt
      status
      user {
        id
        email
        userName
      }
      paper {
        source
        originalID
        version
        originalURL
        originalPDFURL
        title
        abstract
        authors
      }
    }
    tags {
      id
      name
      createdAt
    }
    status
    isFavorite
  }
}
    `;

/**
 * __usePaperQuery__
 *
 * To run a query within a React component, call `usePaperQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaperQuery({
 *   variables: {
 *      paperInput: // value for 'paperInput'
 *   },
 * });
 */
export function usePaperQuery(baseOptions: Apollo.QueryHookOptions<PaperQuery, PaperQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaperQuery, PaperQueryVariables>(PaperDocument, options);
      }
export function usePaperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaperQuery, PaperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaperQuery, PaperQueryVariables>(PaperDocument, options);
        }
export type PaperQueryHookResult = ReturnType<typeof usePaperQuery>;
export type PaperLazyQueryHookResult = ReturnType<typeof usePaperLazyQuery>;
export type PaperQueryResult = Apollo.QueryResult<PaperQuery, PaperQueryVariables>;
export const FindPaperFromSemanticScholarIdDocument = gql`
    query FindPaperFromSemanticScholarID($id: ID!) {
  findPaperFromSemanticScholarID(id: $id) {
    source
    originalID
    version
  }
}
    `;

/**
 * __useFindPaperFromSemanticScholarIdQuery__
 *
 * To run a query within a React component, call `useFindPaperFromSemanticScholarIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPaperFromSemanticScholarIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPaperFromSemanticScholarIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindPaperFromSemanticScholarIdQuery(baseOptions: Apollo.QueryHookOptions<FindPaperFromSemanticScholarIdQuery, FindPaperFromSemanticScholarIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPaperFromSemanticScholarIdQuery, FindPaperFromSemanticScholarIdQueryVariables>(FindPaperFromSemanticScholarIdDocument, options);
      }
export function useFindPaperFromSemanticScholarIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPaperFromSemanticScholarIdQuery, FindPaperFromSemanticScholarIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPaperFromSemanticScholarIdQuery, FindPaperFromSemanticScholarIdQueryVariables>(FindPaperFromSemanticScholarIdDocument, options);
        }
export type FindPaperFromSemanticScholarIdQueryHookResult = ReturnType<typeof useFindPaperFromSemanticScholarIdQuery>;
export type FindPaperFromSemanticScholarIdLazyQueryHookResult = ReturnType<typeof useFindPaperFromSemanticScholarIdLazyQuery>;
export type FindPaperFromSemanticScholarIdQueryResult = Apollo.QueryResult<FindPaperFromSemanticScholarIdQuery, FindPaperFromSemanticScholarIdQueryVariables>;
export const WeeklyRankingsDocument = gql`
    query WeeklyRankings($pagingInput: PagingInput!) {
  weeklyRankings(pagingInput: $pagingInput) {
    edge {
      recordDate
      records {
        order
        score
        paperFull {
          tags {
            id
            name
            createdAt
          }
          paperSources {
            source
            originalID
            version
            originalURL
            originalPDFURL
            title
            abstract
            authors
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    total
  }
}
    `;

/**
 * __useWeeklyRankingsQuery__
 *
 * To run a query within a React component, call `useWeeklyRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyRankingsQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useWeeklyRankingsQuery(baseOptions: Apollo.QueryHookOptions<WeeklyRankingsQuery, WeeklyRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeeklyRankingsQuery, WeeklyRankingsQueryVariables>(WeeklyRankingsDocument, options);
      }
export function useWeeklyRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeeklyRankingsQuery, WeeklyRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeeklyRankingsQuery, WeeklyRankingsQueryVariables>(WeeklyRankingsDocument, options);
        }
export type WeeklyRankingsQueryHookResult = ReturnType<typeof useWeeklyRankingsQuery>;
export type WeeklyRankingsLazyQueryHookResult = ReturnType<typeof useWeeklyRankingsLazyQuery>;
export type WeeklyRankingsQueryResult = Apollo.QueryResult<WeeklyRankingsQuery, WeeklyRankingsQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($query: String!, $limit: Int) {
  searchUsers(query: $query, limit: $limit) {
    profile {
      id
      userName
    }
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const TagPapersDocument = gql`
    query TagPapers($name: String!, $pagingInput: PagingInput!, $eventsPagingInput: PagingInput = {first: 10000}) {
  tag(name: $name) {
    id
    name
    createdAt
    papers(pagingInput: $pagingInput) {
      edge {
        paper {
          source
          originalID
          version
          originalURL
          originalPDFURL
          title
          abstract
          authors
        }
        tags {
          id
          name
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
    events(pagingInput: $eventsPagingInput) {
      edge {
        event
        occurredAt
        user {
          id
          email
          userName
        }
        paper {
          paper {
            source
            originalID
            version
            originalURL
            originalPDFURL
            title
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
    channels {
      channelName
    }
  }
}
    `;

/**
 * __useTagPapersQuery__
 *
 * To run a query within a React component, call `useTagPapersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagPapersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagPapersQuery({
 *   variables: {
 *      name: // value for 'name'
 *      pagingInput: // value for 'pagingInput'
 *      eventsPagingInput: // value for 'eventsPagingInput'
 *   },
 * });
 */
export function useTagPapersQuery(baseOptions: Apollo.QueryHookOptions<TagPapersQuery, TagPapersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagPapersQuery, TagPapersQueryVariables>(TagPapersDocument, options);
      }
export function useTagPapersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagPapersQuery, TagPapersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagPapersQuery, TagPapersQueryVariables>(TagPapersDocument, options);
        }
export type TagPapersQueryHookResult = ReturnType<typeof useTagPapersQuery>;
export type TagPapersLazyQueryHookResult = ReturnType<typeof useTagPapersLazyQuery>;
export type TagPapersQueryResult = Apollo.QueryResult<TagPapersQuery, TagPapersQueryVariables>;
export const TagNameByPrefixDocument = gql`
    query TagNameByPrefix($prefix: String!) {
  tagNamesByPrefix(prefix: $prefix)
}
    `;

/**
 * __useTagNameByPrefixQuery__
 *
 * To run a query within a React component, call `useTagNameByPrefixQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagNameByPrefixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagNameByPrefixQuery({
 *   variables: {
 *      prefix: // value for 'prefix'
 *   },
 * });
 */
export function useTagNameByPrefixQuery(baseOptions: Apollo.QueryHookOptions<TagNameByPrefixQuery, TagNameByPrefixQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagNameByPrefixQuery, TagNameByPrefixQueryVariables>(TagNameByPrefixDocument, options);
      }
export function useTagNameByPrefixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagNameByPrefixQuery, TagNameByPrefixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagNameByPrefixQuery, TagNameByPrefixQueryVariables>(TagNameByPrefixDocument, options);
        }
export type TagNameByPrefixQueryHookResult = ReturnType<typeof useTagNameByPrefixQuery>;
export type TagNameByPrefixLazyQueryHookResult = ReturnType<typeof useTagNameByPrefixLazyQuery>;
export type TagNameByPrefixQueryResult = Apollo.QueryResult<TagNameByPrefixQuery, TagNameByPrefixQueryVariables>;
export const UserCommentsDocument = gql`
    query UserComments($pagingInput: PagingInput!, $id: ID!) {
  user(id: $id) {
    comments(pagingInput: $pagingInput) {
      edge {
        id
        comment
        createdAt
        user {
          id
          email
          userName
        }
        paper {
          source
          originalID
          version
          originalURL
          originalPDFURL
          title
          abstract
          authors
        }
        favorites {
          id
          createdAt
          user {
            id
            email
            userName
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
  }
}
    `;

/**
 * __useUserCommentsQuery__
 *
 * To run a query within a React component, call `useUserCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCommentsQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCommentsQuery(baseOptions: Apollo.QueryHookOptions<UserCommentsQuery, UserCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCommentsQuery, UserCommentsQueryVariables>(UserCommentsDocument, options);
      }
export function useUserCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCommentsQuery, UserCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCommentsQuery, UserCommentsQueryVariables>(UserCommentsDocument, options);
        }
export type UserCommentsQueryHookResult = ReturnType<typeof useUserCommentsQuery>;
export type UserCommentsLazyQueryHookResult = ReturnType<typeof useUserCommentsLazyQuery>;
export type UserCommentsQueryResult = Apollo.QueryResult<UserCommentsQuery, UserCommentsQueryVariables>;
export const UserFavoritesDocument = gql`
    query UserFavorites($pagingInput: PagingInput!, $id: ID!) {
  user(id: $id) {
    favorites(pagingInput: $pagingInput) {
      edge {
        id
        createdAt
        user {
          id
          email
          userName
        }
        paperFull {
          tags {
            id
            name
            createdAt
          }
          paperSources {
            source
            originalID
            version
            originalURL
            originalPDFURL
            title
            abstract
            authors
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
  }
}
    `;

/**
 * __useUserFavoritesQuery__
 *
 * To run a query within a React component, call `useUserFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFavoritesQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserFavoritesQuery(baseOptions: Apollo.QueryHookOptions<UserFavoritesQuery, UserFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFavoritesQuery, UserFavoritesQueryVariables>(UserFavoritesDocument, options);
      }
export function useUserFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFavoritesQuery, UserFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFavoritesQuery, UserFavoritesQueryVariables>(UserFavoritesDocument, options);
        }
export type UserFavoritesQueryHookResult = ReturnType<typeof useUserFavoritesQuery>;
export type UserFavoritesLazyQueryHookResult = ReturnType<typeof useUserFavoritesLazyQuery>;
export type UserFavoritesQueryResult = Apollo.QueryResult<UserFavoritesQuery, UserFavoritesQueryVariables>;
export const UserReadsDocument = gql`
    query UserReads($pagingInput: PagingInput!, $id: ID!) {
  user(id: $id) {
    readPapers(pagingInput: $pagingInput) {
      edge {
        id
        changedAt
        status
        user {
          id
          email
          userName
        }
        paperFull {
          tags {
            id
            name
            createdAt
          }
          paperSources {
            source
            originalID
            version
            originalURL
            originalPDFURL
            title
            abstract
            authors
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
  }
}
    `;

/**
 * __useUserReadsQuery__
 *
 * To run a query within a React component, call `useUserReadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReadsQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserReadsQuery(baseOptions: Apollo.QueryHookOptions<UserReadsQuery, UserReadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserReadsQuery, UserReadsQueryVariables>(UserReadsDocument, options);
      }
export function useUserReadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserReadsQuery, UserReadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserReadsQuery, UserReadsQueryVariables>(UserReadsDocument, options);
        }
export type UserReadsQueryHookResult = ReturnType<typeof useUserReadsQuery>;
export type UserReadsLazyQueryHookResult = ReturnType<typeof useUserReadsLazyQuery>;
export type UserReadsQueryResult = Apollo.QueryResult<UserReadsQuery, UserReadsQueryVariables>;
export const UserReadLatersDocument = gql`
    query UserReadLaters($pagingInput: PagingInput!, $id: ID!) {
  user(id: $id) {
    readLaterPapers(pagingInput: $pagingInput) {
      edge {
        id
        changedAt
        status
        user {
          id
          email
          userName
        }
        paperFull {
          tags {
            id
            name
            createdAt
          }
          paperSources {
            source
            originalID
            version
            originalURL
            originalPDFURL
            title
            abstract
            authors
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
  }
}
    `;

/**
 * __useUserReadLatersQuery__
 *
 * To run a query within a React component, call `useUserReadLatersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReadLatersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReadLatersQuery({
 *   variables: {
 *      pagingInput: // value for 'pagingInput'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserReadLatersQuery(baseOptions: Apollo.QueryHookOptions<UserReadLatersQuery, UserReadLatersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserReadLatersQuery, UserReadLatersQueryVariables>(UserReadLatersDocument, options);
      }
export function useUserReadLatersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserReadLatersQuery, UserReadLatersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserReadLatersQuery, UserReadLatersQueryVariables>(UserReadLatersDocument, options);
        }
export type UserReadLatersQueryHookResult = ReturnType<typeof useUserReadLatersQuery>;
export type UserReadLatersLazyQueryHookResult = ReturnType<typeof useUserReadLatersLazyQuery>;
export type UserReadLatersQueryResult = Apollo.QueryResult<UserReadLatersQuery, UserReadLatersQueryVariables>;
export const UserProfileDocument = gql`
    query UserProfile($id: ID!) {
  user(id: $id) {
    profile {
      id
      email
      userName
    }
    comments(pagingInput: {first: 1}) {
      total
    }
    favorites(pagingInput: {first: 1}) {
      total
    }
    readPapers(pagingInput: {first: 1}) {
      total
    }
    readLaterPapers(pagingInput: {first: 1}) {
      total
    }
  }
}
    `;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserStatsDocument = gql`
    query UserStats($id: ID!) {
  user(id: $id) {
    comments(pagingInput: {first: 10000}) {
      edge {
        createdAt
      }
    }
    favorites(pagingInput: {first: 10000}) {
      edge {
        createdAt
      }
    }
    readPapers(pagingInput: {first: 10000}) {
      edge {
        changedAt
      }
    }
    readLaterPapers(pagingInput: {first: 10000}) {
      edge {
        changedAt
      }
    }
  }
}
    `;

/**
 * __useUserStatsQuery__
 *
 * To run a query within a React component, call `useUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserStatsQuery(baseOptions: Apollo.QueryHookOptions<UserStatsQuery, UserStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserStatsQuery, UserStatsQueryVariables>(UserStatsDocument, options);
      }
export function useUserStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStatsQuery, UserStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserStatsQuery, UserStatsQueryVariables>(UserStatsDocument, options);
        }
export type UserStatsQueryHookResult = ReturnType<typeof useUserStatsQuery>;
export type UserStatsLazyQueryHookResult = ReturnType<typeof useUserStatsLazyQuery>;
export type UserStatsQueryResult = Apollo.QueryResult<UserStatsQuery, UserStatsQueryVariables>;